import * as Sentry from "@sentry/react";
import { LogErrors } from "./LogErrors";

// Fetch medications for a participant
export const fetchMedications = async (participantId, token) => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}Profile/FetchMedications?participantid=${participantId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      const errorMsg = `Error fetching medications. Status: ${response.status} - ${response.statusText}`;
      Sentry.captureMessage(errorMsg, "error");
      // LogErrors(user, logout, updateTokens, errorMsg);
      return null;
    }

    return await response.json();

  } catch (error) {
    // LogErrors(user, logout, updateTokens, "Error fetching medications:", error);
    Sentry.captureException(error);
    return null;
  }
};